import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { MEDIA_URL } from '@/config';
import { useSession } from '@/hooks/useSession';
import { User } from '@/types';
import { cn } from '@/utils/cn';

interface UserAvatarProps {
  className?: string;
  user?: User;
  size?: 'sm' | 'md' | 'lg';
}

export const UserAvatar = ({
  className,
  user,
  size = 'md',
}: UserAvatarProps) => {
  const { data: session } = useSession();
  const currentUser = user || session?.user;

  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'size-7 text-xs';
      case 'lg':
        return 'size-11';
      default:
        return 'size-9';
    }
  };

  const initials = currentUser?.username
    ?.split(' ')
    ?.map((word) => word[0])
    ?.join('')
    ?.toUpperCase();

  return (
    <Avatar className={cn(`${getSizeClass()}`, className)}>
      <AvatarImage
        src={`${
          currentUser?.profile_photo?.includes('https')
            ? currentUser?.profile_photo
            : `${MEDIA_URL}/${currentUser?.profile_photo}`
        }`}
        alt={currentUser?.username}
      />
      <AvatarFallback>{initials}</AvatarFallback>
    </Avatar>
  );
};
